import { Avatar, CssBaseline, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from 'react-router-dom';
import { AppConfig, ReCAPTCHAConfig } from '../../../config/app';
import GlobalStore from '../../../providers/global-store-provider';
import TextInput from '../libs/TextInput';
import { AuthApi } from './../../../providers/api-provider';
import { consumePreferredRoute, handleInputState, inIframe, Loader, postMessageToParent, setCookie, showError, showSuccess } from './../libs/helpers';
import styles from './styles/login';
//Register or Complete Profile
class DonorRegister extends React.Component {

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  state = {
    loading: false,
    completeProfile: false,
    form: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      recaptcha: '',
    },
    errors: {
      first_name: false,
      last_name: false,
      email: false,
      password: false,
    },

  };
  recaptchaRef = React.createRef()
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  /* API Call */
  performRegisterAction = () => {
    if (this.checkErrors()) {
      let data = this.state.form;
      this.setState({ loading: true });
      data.role = 'donor';
      //Register or Complete Donor Profile Data
      AuthApi[this.state.completeProfile ? 'completeProfile' : 'register'](data)
        .then((res) => {
          //Set cookie for wordpress website
          setCookie('x_t', res.data.token);
          //Show SnackBar
          showSuccess('Welcome Home', 'success');
          this.setState({ loading: false });
          GlobalStore.auth.login(res.data);
          //If it was called from edseed.me send a message
          if (inIframe()) {
            postMessageToParent('login', {
              loggedIn: true,
              userInfo: res.data
            });
            return;
          }
          //If there is preferred route go to it
          const redirectTo = consumePreferredRoute('donor');
          if (redirectTo) {
            if (redirectTo.indexOf('http') === 0)
              window.location.href = redirectTo;
            else
              this.props.history.push(redirectTo);
            return;
          }
          this.props.history.push('/');
        }).catch((error) => {
          //Reset Recaptcha
          if (this.recaptchaRef && this.recaptchaRef.current)
            this.recaptchaRef.current.props.grecaptcha.reset();
          let newState = this.state;
          let navigateTo = false;
          //Show SnackBar
          showError(error);
          if (typeof (error.response) !== 'undefined' && typeof (error.response.data.errors) !== 'undefined') {
            for (let field in this.state.errors) {
              if (typeof (error.response.data.errors[field]) !== "undefined") {
                newState.errors[field] = error.response.data.errors[field][0];
                //prepare navigate to first error step fragment
                if (!navigateTo)
                  navigateTo = field;
              } else
                newState.errors[field] = false;
            }
            newState.errors.enabled = true;
          }
          newState.loading = false;
          console.log(error);
          this.setState(newState);
        });
    }

  }

  componentDidMount() {
    if (GlobalStore.state.auth.loggedIn) {
      let form = this.state.form;
      let user = GlobalStore.state.auth.user;
      form.first_name = user.first_name;
      form.last_name = user.name.replace(user.first_name + ' ', '');
      form.email = user.email;
      this.setState({ form: form, completeProfile: true });
    } else {

      let form = this.state.form;
      let errors = this.state.errors;
      form.email = '';
      form.password = '';
      errors.email = false;
      errors.password = false;
      this.setState({ errors: errors, form: form });
    }
  }
  /*
 -----------------------------------------------------------------------
 RENDER Functions
 -----------------------------------------------------------------------
 */

  onReCapatchChange = (value) => {
    let form = { ...this.state.form, recaptcha: value };
    this.setState({ form });
  }
  /* Validate Form */
  checkErrors = () => {
    let errors = { enabled: false };
    for (let field in this.state.errors) {
      if (field === 'enabled') continue;
      errors[field] = this.state.form[field] === '' || this.state.form[field] === null;
      if (errors[field]) {
        errors.enabled = true;
        //prepare navigate to first error step fragment
      }
    }
    this.setState({
      errors: errors,
    });
    return !errors.enabled;
  }
  /* Hanle State Management of form */
  onChange = handleInputState
  render() {
    const { classes } = this.props;
    const { errors, form, loading, completeProfile } = this.state;

    return (

      <main className={classes.main}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <img alt='edSeed Logo' src={AppConfig.base + '/logo.png?v1'} style={{ width: '95%' }} />
          </Avatar>
          <Typography component="h1" variant="h5" style={{ width: '100%' }}>
            Sign Up
          </Typography>
          <form className={classes.form}>
            <Grid container spacing={12}>
              <TextInput
                width={12}
                error={errors.first_name}
                value={form.first_name}
                enabled={errors.enabled}
                onChange={this.onChange}
                name='first_name'
                title='First Name'
              />
              <TextInput
                width={12}
                error={errors.last_name}
                value={form.last_name}
                enabled={errors.enabled}
                onChange={this.onChange}
                name='last_name'
                title='Last Name'
              />
              {!completeProfile && [
                <TextInput
                  width={12}
                  error={errors.email}
                  value={form.email}
                  enabled={errors.enabled}
                  onChange={this.onChange}
                  name='email'
                  type='email'
                  title='Email'
                  key={1}
                />,
                <TextInput
                  width={12}
                  error={errors.password}
                  value={form.password}
                  enabled={errors.enabled}
                  onChange={this.onChange}
                  name='password'
                  type='password'
                  title='Password'
                  required={true}
                  key={2}
                />
              ]
              }
              <ReCAPTCHA
                sitekey={ReCAPTCHAConfig.site_key}
                onChange={this.onReCapatchChange}
                ref={this.recaptchaRef}
              />
              <Typography component="h5" className='fullwidth' style={{ marginTop: 12, marginBottom: 12 }}>
                I accept the site <a href="https://www.edseed.me/terms-conditions/" target='_blank'>Terms of Service</a> and agree to the <a href='https://www.edseed.me/privacy-policy/' target='_blank'>Privacy Policy</a>.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => this.performRegisterAction()}
                className={classes.button}
                disabled={loading}
              >
                {(loading ? <Loader size={20} /> : (completeProfile ? 'Complete Profile' : 'Register'))}
              </Button>

              <Typography component="h5" className='toppadding-xs text-center fullwidth'>
                Have an account, login <Button className='nopadding' autoCapitalize={false} variant='text' color='primary' style={{ minWidth: 0 }} to='/login' component={Link}>Here</Button>
              </Typography>
            </Grid>
          </form>
        </Paper>
      </main>

    );
  }
}

DonorRegister.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DonorRegister);
